import { useMutation } from "@tanstack/react-query";
import { mutations } from "@core-shop/cache";

export function useUpdateNotificationsSettings() {
  return useMutation(mutations.updateNotifications());
}
